import * as React from 'react';
import * as L from 'leaflet';
import { FeatureGroup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import "leaflet-draw/dist/leaflet.draw-src.css";

export default function EditControlPOI({ poiSelect, setEditRef, handleCreated, refControlPOI, editResize, editMove }) {
    React.useEffect(() => {
        L.Draw.Polyline.prototype._onTouch = L.Util.falseFn;
    }, [])
    React.useEffect(() => {
        const GeoJSONeachLayer = () => {
            L.geoJSON(poiSelect, {
                pointToLayer: function (feature, latlng) {
                    return L.circle(latlng, {
                        radius: Math.floor(feature.properties.radius),
                        // units: 'meters',
                    })
                },
                style: { color: '#9FB398' },
            }).eachLayer((layer) => {
                if (layer.feature.properties.shape === "rectangle") {
                    // console.log('layer', layer.feature)
                    const rectangleLayer = L.rectangle(layer.getBounds()).setStyle({ color: '#9FB398' });
                    refControlPOI.current?.addLayer(rectangleLayer)
                    return
                }

                if (layer.feature.geometry.type === "LineString") {
                    // console.log('layer', layer.feature)
                    const rectangleLayer = L.polyline(layer.getLatLngs()).setStyle({ color: '#9FB398' });
                    refControlPOI.current?.addLayer(rectangleLayer)
                    return
                }

                if (layer.feature.properties.shape === "polygon") {
                    const polygonLayer = L.polygon(layer.getLatLngs()).setStyle({ color: '#9FB398' });
                    refControlPOI.current?.addLayer(polygonLayer)
                    return
                }

                refControlPOI.current?.addLayer(layer)
            });
        }

        if (refControlPOI.current?.getLayers().length === 0 && poiSelect) {
            GeoJSONeachLayer()
        } else {
            refControlPOI.current.clearLayers()
            GeoJSONeachLayer()
        }
    }, [poiSelect, refControlPOI]);


    return (
        <FeatureGroup ref={refControlPOI}>
            <EditControl
                onMounted={(ref) => {
                    setEditRef(ref)
                }}
                draw={
                    {
                        polygon: {
                            guidelineDistance: 10,
                        }
                    }
                }
                onCreated={(e) => {
                    if (e.layerType === "circle") {
                        const circle = e.layer.toGeoJSON()
                        const _circle = { ...circle, properties: { ...circle.properties, "shape": "circle", radius: e.layer.getRadius() } }
                        handleCreated(_circle)

                        return
                    }

                    if (e.layerType === "polyline") {
                        const polyline = e.layer.toGeoJSON()
                        const _polyline = { ...polyline, properties: { ...polyline.properties, "shape": "polyline" } }
                        handleCreated(_polyline)
                        return
                    }
                    if (e.layerType === "rectangle") {
                        const rectangle = e.layer.toGeoJSON()
                        const _rectangle = { ...rectangle, properties: { ...rectangle.properties, "shape": "rectangle" } }
                        handleCreated(_rectangle)
                        return
                    }
                    if (e.layerType === "polygon") {
                        const rectangle = e.layer.toGeoJSON()
                        const _rectangle = { ...rectangle, properties: { ...rectangle.properties, "shape": "polygon" } }
                        handleCreated(_rectangle)
                        return
                    }

                }}
                onEditMove={(e) => {

                    if (typeof e.layer.getLatLng === 'function') {
                        const latLng = e.layer.getLatLng()
                        editMove([latLng.lng, latLng.lat])
                        return
                    }

                    if (typeof e.layer.getLatLngs === 'function') {
                        const latLngs = e.layer.toGeoJSON().geometry.coordinates
                        editMove(latLngs)
                        return
                    }


                }}
                onEditResize={(e) => {
                    if (typeof e.layer.getRadius === 'function') {
                        const radius = e.layer.getRadius()
                        editResize(Math.floor(radius))
                        return
                    }

                    if (typeof e.layer.getLatLngs === 'function') {
                        const latLngs = e.layer.toGeoJSON().geometry.coordinates
                        editMove(latLngs)
                        return
                    }
                }}
                onEditVertex={e => {
                    const latLngs = e.poly.toGeoJSON().geometry.coordinates
                    editMove(latLngs)
                }}
            />
        </FeatureGroup>
    );
}